import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import './styles/main.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {BrowserRouter} from 'react-router-dom';
import { PrimeReactProvider } from 'primereact/api';

import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';

ReactDOM.render(
    <BrowserRouter>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
